var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-list-item',{on:{"click":_vm.print}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"left":""}},[_vm._v("fa-print")])],1),_c('v-list-item-title',[_vm._v("Generar Reporte")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }